import { render } from "./ContactNssiModal.vue?vue&type=template&id=5e637507&scoped=true"
const script = {}

import "./ContactNssiModal.vue?vue&type=style&index=0&id=5e637507&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e637507"]])

export default __exports__